import * as React from "react";
import { forwardRef, memo } from "react";
const SvgArrowDropDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9 11.25L5.25 7.5H12.75L9 11.25Z", fill: "black" }));
const ForwardRef = forwardRef(SvgArrowDropDown);
const Memo = memo(ForwardRef);
export { Memo as ReactComponent };
